define([
	"dojo/_base/declare",
	"dojo/when",
	"csi/_base/Deferred",
	"csi/_base/underscore",
	"./Request",
	"./Values"
], function(declare,when,Deferred,_,Request,Values) {

	var	_notSupported = function() {
		// summary: not supported
		console.assert(false);
	};

	return declare(Request, {
		// Store only supports query API
		add: _notSupported,
		put: _notSupported,
		remove: _notSupported,

		// String: properties taken from _valuesStore
		//countProperty: null,
		//idProperty: null,
		//indexProperty: null,
		//labelProperty: null,
		//refsProperty: null,

		// Spec: spec for first grouped-by attribute (used when creating Values store for second level grouping); used to filter result Nodes before extracting Values
		//filterSpec: null,

		// Spec: spec for grouped-by attribute
		//spec: null,

		// Object: options to use for Values store
		//valuesStoreOptions: null,

		// Any: value for filterSpec; used to filter pairs data when extracting Values for spec
		//_filterValue: null,

		// Values: store containing resulting values and counts
		//_valuesStore: null,

		get: function(/*String*/id) {
			// summary: forward to values store
			return this._valuesStore.get(id);
		},

		getResultTotal: function(/*Number?*/nDisplayed) {
			// summary: forward to values store
			return this._valuesStore ? this._valuesStore.getResultTotal(nDisplayed) : 0;
		},

		_createQueryRequest: function(/*Object?*/query, /*Object?*/options) {
			// summary: "query" should include all ad-hoc filters for main store in addition to any group filters if using nested grouping;
			// "options" could include sorting parameters
			var	dfd = new Deferred();

			// if two levels of grouping, then query will contain entry for first-level group value
			var	filterKey = this.filterSpec && this.filterSpec.queryKey;

			if (filterKey && query && (query[filterKey] != null)) {
				// in this case, "_store" is already loaded and need to do client-side filtering of the available data to get values;
				// extract first-level group value from query and defer filtering until after query results are received
				this._filterValue = query[filterKey][0];
				query = null;
				options = {useCache: true};
			}

			// requesting new values so unload current data
			this._valuesStore = null;

			// query store and wait for reply
			when(this._store.query(query, options),
				function(results) {
					dfd.resolve(results);
				},
				function(err) {
					dfd.reject(err);
				}
			);

			return dfd;
		},

		_doQuery: function(query, options) {
			// summary: forward to values store
			return this._valuesStore.query(query, options);
		},

		_onData: function(/*Object[]*/data, /*Object*/options) {
			// summary: create Values store from Nodes if not already created
			var store = this._valuesStore = this._onDataCreateValuesStore(data, _.extend({
				spec: this.spec
			}, this.valuesStoreOptions));

			this.countProperty = store.countProperty;
			this.idProperty = store.idProperty;
			this.labelProperty = store.labelProperty;
			this.indexProperty = store.indexProperty;
			this.refsProperty = store.refsProperty;
		},

		_onDataCreateValuesStore: function(/*Object[]*/data, /*Object*/storeOptions) {
			// summary: derived class to implement
			console.assert(false);
		}
	});
});